import type { SubscriptionItemStatus } from '~/shared/data-contract/subscription-item';

export const companySettingsKeys = {
    all: ['company-settings'] as const,
    companyProfile: () => [...companySettingsKeys.all, 'company-profile'] as const,
    companyProfilePolling: () => [...companySettingsKeys.all, 'company-profile-polling'] as const,
    companyProfilePollingUntil: () => [...companySettingsKeys.all, 'company-profile-polling-until'] as const,
    companySettings: () => [...companySettingsKeys.all, 'settings'] as const,
    jobArchitectures: () => [...companySettingsKeys.all, 'job-architectures'] as const,
    metadata: (jobArchitectureId: string) => [...companySettingsKeys.all, 'metadata', jobArchitectureId] as const,
    organizationLanguages: () => [...companySettingsKeys.all, 'organization-languages'] as const,
    organizationStatistics: () => [...companySettingsKeys.all, 'organization-statistics'] as const,
    subscription: () => [...companySettingsKeys.all, 'subscription'] as const,
    subscriptionItems: (status?: readonly SubscriptionItemStatus[], language?: string) =>
        [...companySettingsKeys.all, 'subscription-items', status ?? [], language ?? ''] as const,
    subscriptionItemsAll: () => [...companySettingsKeys.all, 'subscription-items'] as const,
    organizationUsers: () => [...companySettingsKeys.userManagement(), 'users'] as const,
    organizationUsersInfinite: (searchTerm?: string, sortOrder?: string) =>
        [...companySettingsKeys.organizationUsersInfiniteAll(), searchTerm ?? '', sortOrder ?? 'asc'] as const,
    organizationUsersInfiniteAll: () => [...companySettingsKeys.userManagement(), 'users-infinite'] as const,
    userManagement: () => [...companySettingsKeys.all, 'user-management'] as const,
    managedJobProfileTemplates: () => [...companySettingsKeys.all, 'managed-job-profile-templates'] as const,
    customJobProfileTemplate: (jobArchitectureId: string) =>
        [...companySettingsKeys.all, 'custom-job-profile-template', jobArchitectureId] as const,
} as const;
